import AcademicMobilityCreationPage from "./AcademicMobilityCreationPage";

export default AcademicMobilityCreationPage;